import { ServiceIcon, Spacer, Text } from "@zapier/design-system";
import { Tooltip, TOOLTIP_PLACEMENTS } from "@zapier/design-system-beta";

import styles from "./SummaryApps.module.css";
import getAppIconUrl from "../../utils/getAppIconUrl";
import useServiceById from "../../hooks/useServiceById";
import cleanUpAppId from "../../utils/cleanUpAppId";

type Props = {
  uniqueApps: string[];
  tooltipPosition?: (typeof TOOLTIP_PLACEMENTS)[number];
  darkMode?: boolean;
};

export function SummaryApps({
  uniqueApps,
  tooltipPosition = "top",
  darkMode = false,
}: Props) {
  const getService = useServiceById();

  return (
    <>
      <Text type="SmallPrint3" color={darkMode ? "PrimeWhite" : "GrayWarm10"}>
        Apps
      </Text>
      <Spacer height={5} />
      {uniqueApps.length === 0 && (
        <Text type="SmallPrint1" color="GrayWarm6">
          <span>Software referenced will be displayed here.</span>
        </Text>
      )}
      {uniqueApps.length > 0 && (
        <ul className={styles.appsList}>
          {uniqueApps.map((appId) => {
            const service = getService(appId);
            const serviceName = service?.name ?? cleanUpAppId(appId);
            const images = service?.images;
            const size = 40;

            return (
              <li className={styles.appItem} key={appId}>
                <Tooltip placement={tooltipPosition} content={serviceName}>
                  <Tooltip.FocusableTrigger>
                    <ServiceIcon
                      alt={`${serviceName} icon`}
                      hasBorder={true}
                      size={size}
                      hasShadow={false}
                      serviceName={serviceName}
                      src={getAppIconUrl(appId, images, size)}
                    />
                  </Tooltip.FocusableTrigger>
                </Tooltip>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
